import store from "../store";

// token config
export const tokenConfig = (getState = store.getState) => {
  const token = getState().auth.token;

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  if (token) {
    config.headers["Authorization"] = `Token ${token}`;
  }
  return config;
};

// set content type to form-data
export const imageUploadConfig = (getState = store.getState) => {
  const config = tokenConfig(getState);
  config.headers["Content-Type"] = "multipart/form-data";
  return config;
};

export const getFormData = (data) => {
  let formData = Object.keys(data).reduce((formData, key) => {
    formData.append(key, data[key]);
    return formData;
  }, new FormData());
  return formData;
};

export function getErrorString(object, noKey = null, asArray = null) {
  try {
    const stringArray = Object.keys(object).map((key, index) => {
      let value = object[key];
      return noKey ? value : `${key}: ${value}`;
    });
    if (asArray) return stringArray;
    return stringArray.join("  ");
  } catch (error) {
    return null;
  }
}
export function GetErrorComponent({ object, altText, noKey }) {
  const errorArray = getErrorString(object, noKey, true);
  const elements = errorArray?.map((error, i) => <div key={i}>{error}</div>);
  return <>{elements || altText}</>;
}
